module.exports = __webpack_public_path__ + "static/media/NatashaSchmid_Resume_Win20.6866d9a2.pdf";